(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[980],{

/***/ 5829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[userId]",
      function () {
        return __webpack_require__(4153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9817:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-green.2a508d0e.png","height":911,"width":3950,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEUaqFYZp1UZqFUdqVhrotV3AAAABHRSTlMsFg8hii2lTwAAAAlwSFlzAAAOvwAADr8BOAVTJAAAABdJREFUCJljYGBgZGJiZGRiYGBgZgABAACUAA1o9/y9AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 4045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 3421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6038);


function useSelector(initialValue) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialValue);
    var q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].utils.selector */ .ZP.utils.selector(ref);
    }, [
        ref
    ]);
    return [
        q,
        ref
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useSelector);


/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ review_Review; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/react-calendly/dist/index.es.js
var index_es = __webpack_require__(761);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(6546);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(4045);
// EXTERNAL MODULE: ./src/hooks/useSelector.tsx
var useSelector = __webpack_require__(3421);
;// CONCATENATED MODULE: ./src/page-components/review/Contact/Contact.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
var Contact = function(props) {
    var ref23, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var ref18 = _slicedToArray((0,useSelector/* default */.Z)(null), 2), q = ref18[0], mainRef = ref18[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        ScrollTrigger.ScrollTrigger.matchMedia({
            // desktop
            '(min-width: 48em)': function() {
                var textAnimation = gsap/* default.fromTo */.ZP.fromTo(q('#review-booking-text'), {
                    y: 400,
                    opacity: 0,
                    delay: 2
                }, {
                    y: 0,
                    duration: 1.5,
                    opacity: 1,
                    scrollTrigger: {
                        id: 'parallax',
                        trigger: q('#review-booking-text'),
                        start: function() {
                            return '-=400 bottom';
                        },
                        end: '-=300 bottom',
                        markers: false,
                        toggleActions: 'pause play none none'
                    }
                });
                var contactAnimatiion = gsap/* default.fromTo */.ZP.fromTo(q('#review-booking-text2'), {
                    x: -200,
                    delay: 2,
                    opacity: 0
                }, {
                    opacity: 1,
                    x: 0,
                    duration: 2.2,
                    scrollTrigger: {
                        id: 'parallax',
                        trigger: q('#review-booking-text'),
                        start: function() {
                            return '-=200 bottom';
                        },
                        end: '-=100 bottom',
                        markers: false,
                        toggleActions: 'pause play none none'
                    }
                });
                var calendlyAnimation = gsap/* default.fromTo */.ZP.fromTo(q('#review-booking-calendar'), {
                    x: 500,
                    delay: 2,
                    opacity: 0
                }, {
                    x: 100,
                    duration: 2.2,
                    opacity: 1,
                    scrollTrigger: {
                        id: 'parallax',
                        trigger: q('#review-booking-text'),
                        start: function() {
                            return '-=100 bottom';
                        },
                        end: '-=100 bottom',
                        markers: false,
                        toggleActions: 'pause play none none'
                    }
                });
                return function() {
                    var ref, ref21, ref22;
                    (ref = textAnimation.scrollTrigger) === null || ref === void 0 ? void 0 : ref.kill();
                    textAnimation.kill();
                    (ref21 = contactAnimatiion.scrollTrigger) === null || ref21 === void 0 ? void 0 : ref21.kill();
                    contactAnimatiion.kill();
                    (ref22 = calendlyAnimation.scrollTrigger) === null || ref22 === void 0 ? void 0 : ref22.kill();
                    calendlyAnimation.kill();
                };
            }
        });
    }, []);
    var ref19, ref20;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        ref: mainRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            centerContent: true,
            minH: "50vh",
            maxW: "container.xl",
            w: "container.xl",
            pt: {
                base: 40,
                md: 20
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: {
                        base: 0,
                        md: 60
                    },
                    pb: {
                        base: 40,
                        md: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                        id: "review-booking-text",
                        pb: {
                            base: 0,
                            md: 10
                        },
                        fontSize: "4xl",
                        px: "50",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                children: "Book a free 60 Minute Consultation (Usually $250)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                children: "and learn how you can fix these problems on your website."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                    overflow: "hidden",
                    direction: {
                        base: 'column',
                        md: 'row'
                    },
                    w: "full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                            id: "review-booking-text2",
                            direction: {
                                base: 'row',
                                md: 'column'
                            },
                            spacing: {
                                base: 10,
                                md: 0
                            },
                            alignItems: "left",
                            px: {
                                base: 50,
                                md: 0
                            },
                            mt: {
                                base: 0,
                                md: '66px'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    mb: 10,
                                    alignSelf: "left",
                                    w: {
                                        base: '350px',
                                        md: '250px'
                                    },
                                    h: {
                                        base: '350px',
                                        md: '250px'
                                    },
                                    position: "relative",
                                    rounded: "3xl",
                                    boxShadow: "xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        priority: true,
                                        objectFit: "contain",
                                        layout: "fill",
                                        src: ((ref23 = props.review) === null || ref23 === void 0 ? void 0 : (ref1 = ref23.chacraRepPhoto) === null || ref1 === void 0 ? void 0 : ref1.publicUrl) ? (ref2 = props.review) === null || ref2 === void 0 ? void 0 : ref2.chacraRepPhoto.publicUrl : 'https://res.cloudinary.com/hfq3eckim/image/upload/v1650618658/csv2/Icons/istockphoto-1220827245-170667a_kgvkfs.png',
                                        alt: "contact-person"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                                    fontSize: {
                                        base: '4xl',
                                        md: '3xl'
                                    },
                                    alignSelf: "center",
                                    spacing: 35,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                                            display: {
                                                base: 'none',
                                                md: 'contents'
                                            },
                                            spacing: 0,
                                            alignItems: "center",
                                            textAlign: "left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    textAlign: "left",
                                                    children: "Book a time for your"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    textAlign: "left",
                                                    children: "complimentary consultation"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            display: {
                                                base: 'contents',
                                                md: 'none'
                                            },
                                            textAlign: "left",
                                            children: "Book a time for your complimentary consultation"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                                            spacing: 0,
                                            alignItems: "left",
                                            textAlign: "left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    children: "Alternatively give us a call on"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    textAlign: "left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: (ref3 = props.review) === null || ref3 === void 0 ? void 0 : ref3.chacraRepPhoneNo
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            display: {
                                base: 'none',
                                md: 'flex'
                            },
                            alignSelf: {
                                base: 'center',
                                md: 'top'
                            },
                            id: "review-booking-calendar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* InlineWidget */.KS, {
                                styles: {
                                    height: '1100px',
                                    width: '650px',
                                    marginTop: 0
                                },
                                url: (ref19 = (ref4 = props.review) === null || ref4 === void 0 ? void 0 : ref4.chacraRepCalendlyURL) !== null && ref19 !== void 0 ? ref19 : '',
                                prefill: {
                                    name: ((ref5 = props.review) === null || ref5 === void 0 ? void 0 : ref5.leadName) ? (ref6 = props.review) === null || ref6 === void 0 ? void 0 : ref6.leadName : '',
                                    email: ((ref7 = props.review) === null || ref7 === void 0 ? void 0 : ref7.email) ? (ref8 = props.review) === null || ref8 === void 0 ? void 0 : ref8.email : '',
                                    location: 'UAE',
                                    customAnswers: {
                                        a1: ((ref9 = props.review) === null || ref9 === void 0 ? void 0 : ref9.phoneNumber) ? (ref10 = props.review) === null || ref10 === void 0 ? void 0 : ref10.phoneNumber : ''
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            display: {
                                base: 'flex',
                                md: 'none'
                            },
                            alignSelf: {
                                base: 'center',
                                md: 'none'
                            },
                            id: "review-booking-calendar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* InlineWidget */.KS, {
                                styles: {
                                    height: '1100px',
                                    width: '1100px',
                                    marginTop: 0
                                },
                                url: (ref20 = (ref11 = props.review) === null || ref11 === void 0 ? void 0 : ref11.chacraRepCalendlyURL) !== null && ref20 !== void 0 ? ref20 : '',
                                prefill: {
                                    name: ((ref12 = props.review) === null || ref12 === void 0 ? void 0 : ref12.leadName) ? (ref13 = props.review) === null || ref13 === void 0 ? void 0 : ref13.leadName : '',
                                    email: ((ref14 = props.review) === null || ref14 === void 0 ? void 0 : ref14.email) ? (ref15 = props.review) === null || ref15 === void 0 ? void 0 : ref15.email : '',
                                    location: 'UAE',
                                    customAnswers: {
                                        a1: ((ref16 = props.review) === null || ref16 === void 0 ? void 0 : ref16.phoneNumber) ? (ref17 = props.review) === null || ref17 === void 0 ? void 0 : ref17.phoneNumber : ''
                                    }
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Contact_Contact = (Contact);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/slider/dist/chakra-ui-slider.esm.js
var chakra_ui_slider_esm = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 56 modules
var chakra_ui_menu_esm = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/assets/images/logo-green.png
var logo_green = __webpack_require__(9817);
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/fastForwardIcon.svg
/* harmony default export */ var fastForwardIcon = ({"src":"/_next/static/media/fastForwardIcon.166ce428.svg","height":30,"width":32});
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/fullScreenIcon.svg
/* harmony default export */ var fullScreenIcon = ({"src":"/_next/static/media/fullScreenIcon.3e5a1928.svg","height":34,"width":34});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/pauseIcon.svg
/* harmony default export */ var pauseIcon = ({"src":"/_next/static/media/pauseIcon.dcb7f141.svg","height":29,"width":20});
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/playIcon.svg
/* harmony default export */ var playIcon = ({"src":"/_next/static/media/playIcon.f612a990.svg","height":29,"width":21});
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(2004);
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/reverseIcon.svg
/* harmony default export */ var reverseIcon = ({"src":"/_next/static/media/reverseIcon.f2f071e1.svg","height":30,"width":32});
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/settingsIcon.svg
/* harmony default export */ var settingsIcon = ({"src":"/_next/static/media/settingsIcon.a967240b.svg","height":32,"width":38});
;// CONCATENATED MODULE: ./src/assets/images/playerIcons/volumeIcon.svg
/* harmony default export */ var volumeIcon = ({"src":"/_next/static/media/volumeIcon.b94f74ae.svg","height":34,"width":41});
// EXTERNAL MODULE: ./node_modules/screenfull/dist/screenfull.js
var screenfull = __webpack_require__(577);
var screenfull_default = /*#__PURE__*/__webpack_require__.n(screenfull);
;// CONCATENATED MODULE: ./src/page-components/review/HeaderAndVideo/HeaderVideo.tsx
function HeaderVideo_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function HeaderVideo_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function HeaderVideo_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function HeaderVideo_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function HeaderVideo_slicedToArray(arr, i) {
    return HeaderVideo_arrayWithHoles(arr) || HeaderVideo_iterableToArrayLimit(arr, i) || HeaderVideo_unsupportedIterableToArray(arr, i) || HeaderVideo_nonIterableRest();
}
function HeaderVideo_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return HeaderVideo_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HeaderVideo_arrayLikeToArray(o, minLen);
}



















gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
var format = function(seconds) {
    if (isNaN(seconds)) {
        return "00:00";
    }
    var date = new Date(seconds * 1000);
    var hh = date.getUTCHours();
    var mm = date.getUTCMinutes();
    var ss = date.getUTCSeconds().toString().padStart(2, '0');
    if (hh) {
        return "".concat(hh, ":").concat(mm.toString().padStart(2, '0'), ":").concat(ss);
    }
    return "".concat(mm, ":").concat(ss);
};
var HeaderVideo = function(props) {
    var ref18, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = HeaderVideo_slicedToArray((0,useSelector/* default */.Z)(null), 2), q = ref9[0], mainRef = ref9[1];
    var playerRef = (0,react.useRef)(null);
    var videoBoxRef = (0,react.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var tl = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), mainPlay = ref10[0], setMainPlay = ref10[1];
    var ref11 = (0,react.useState)(true), play = ref11[0], setPlay = ref11[1];
    var ref12 = (0,react.useState)(1), volume = ref12[0], setVolume = ref12[1];
    var ref13 = (0,react.useState)(false), isMuted = ref13[0], setIsMuted = ref13[1];
    var ref14 = (0,react.useState)(1), playbackRate = ref14[0], setPlaybackRate = ref14[1];
    var ref15 = (0,react.useState)(0), played = ref15[0], setPlayed = ref15[1];
    var ref16 = (0,react.useState)(false), seeking = ref16[0], setSeeking = ref16[1];
    var ref17 = (0,react.useState)(false), showVolumeSlider = ref17[0], setShowVolumeSlider = ref17[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        tl.current = gsap/* default.timeline */.ZP.timeline({
            onComplete: function() {
                tl.current.to(q('#review-video'), {
                    y: 0,
                    rotation: 0,
                    transformOrigin: 'left top',
                    duration: 1,
                    delay: 0.5
                });
            }
        });
        ScrollTrigger.ScrollTrigger.matchMedia({
            // desktop
            '(min-width: 48em)': function() {
                var ref19;
                (ref19 = tl.current) === null || ref19 === void 0 ? void 0 : ref19.fromTo(q('#review-video'), {
                    y: -1000,
                    scale: 0.3
                }, {
                    y: -200,
                    scale: 1,
                    duration: 1.5,
                    delay: 0.1
                });
                tl.current.to(q('#review-video'), {
                    y: 0,
                    rotation: -2,
                    transformOrigin: 'left top',
                    duration: 0.5,
                    delay: 0.3
                });
                tl.current.fromTo(q('#heading-section'), {
                    y: 200,
                    opacity: 0,
                    delay: 0.1
                }, {
                    y: 0,
                    opacity: 1,
                    duration: 0.5
                }, '<');
                tl.current.fromTo(q('#header-chacra'), {
                    x: -300
                }, {
                    x: 0,
                    duration: 0.5
                }, '<');
                tl.current.to(q('#review-video'), {
                    rotation: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    transformOrigin: 'left top',
                    scrollTrigger: {
                        id: 'parallax',
                        trigger: q('#review-video'),
                        start: '300px 30%',
                        end: '+=900',
                        markers: false,
                        toggleActions: 'pause play none none'
                    }
                });
                return function() {
                    var ref;
                    (ref = tl.current.scrollTrigger) === null || ref === void 0 ? void 0 : ref.kill();
                    tl.current.kill();
                };
            }
        });
    }, []);
    var currentTime = playerRef && playerRef.current ? playerRef.current.getCurrentTime() : '00:00';
    var duration = playerRef && playerRef.current ? playerRef.current.getDuration() : '00:00';
    var elapsedTime = format(currentTime);
    var totalDuration = format(duration);
    var handleRewind = function() {
        var ref;
        (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(playerRef.current.getCurrentTime() - 5);
    };
    var handleFastForward = function() {
        var ref;
        (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(playerRef.current.getCurrentTime() + 5);
    };
    var handleVolumeChange = function(newValue) {
        console.log(newValue);
        setVolume(parseFloat((newValue / 100).toLocaleString()));
        setIsMuted(newValue === 0 ? true : false);
    };
    var handleProgress = function(changeState) {
        if (!seeking) {
            setPlayed(changeState.played);
        }
    };
    var handleSeekChange = function(newValue) {
        setPlayed(parseFloat((newValue / 100).toString()));
    };
    var handleSeekMouseDown = function() {
        setSeeking(true);
    };
    var handleSeekMouseUp = function(newValue) {
        var ref;
        setSeeking(false);
        (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(newValue / 100, 'fraction');
    };
    var toggleFullScreen = function() {
        if (videoBoxRef.current && window.document && document !== undefined) screenfull_default().toggle(videoBoxRef.current);
    };
    var playVideo = function() {
        setMainPlay(true);
        gsap/* default.to */.ZP.to(q('#review-video'), {
            rotation: 0,
            duration: 0.5,
            ease: 'power2.out'
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        ref: mainRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                id: "header-chacra",
                position: "absolute",
                top: {
                    base: 20,
                    md: '10'
                },
                left: "0",
                w: {
                    base: 'container.xl',
                    md: 'full'
                },
                justifyContent: {
                    base: 'center',
                    md: 'space-between'
                },
                alignItems: "center",
                px: {
                    md: '6',
                    lg: '12'
                },
                h: {
                    base: '100px',
                    md: '100px'
                },
                zIndex: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            h: "100px",
                            w: {
                                base: '150px',
                                md: '160px',
                                lg: '180px'
                            },
                            position: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: logo_green/* default */.Z,
                                layout: "responsive",
                                objectFit: "contain",
                                priority: true,
                                alt: "chacra-logo"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
                centerContent: true,
                minH: "100vh",
                maxW: "container.xl",
                w: "container.xl",
                pt: {
                    base: 40,
                    md: 40
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: {
                        base: 40,
                        md: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                            spacing: {
                                base: 10,
                                md: 0
                            },
                            flexDirection: {
                                base: 'column',
                                md: 'row'
                            },
                            id: "heading-section",
                            h: {
                                md: '100px'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    alignSelf: "center",
                                    id: "heading-logo",
                                    mr: {
                                        md: 10
                                    },
                                    w: {
                                        base: '400px',
                                        md: '327px'
                                    },
                                    h: {
                                        base: '200px',
                                        md: 'full'
                                    },
                                    position: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        priority: true,
                                        objectFit: "fill",
                                        layout: "fill",
                                        src: ((ref18 = props.review) === null || ref18 === void 0 ? void 0 : (ref1 = ref18.logo) === null || ref1 === void 0 ? void 0 : ref1.publicUrl) ? (ref2 = props.review) === null || ref2 === void 0 ? void 0 : ref2.logo.publicUrl : '',
                                        alt: "review-logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    alignSelf: "center",
                                    id: "heading-divider",
                                    h: {
                                        base: '0',
                                        md: '80px'
                                    },
                                    w: {
                                        base: '500px',
                                        md: '0px'
                                    },
                                    borderLeft: {
                                        md: '4px'
                                    },
                                    borderBottom: {
                                        base: '8px',
                                        md: 0
                                    },
                                    borderColor: "#006400"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    w: {
                                        base: '800px',
                                        md: 'full'
                                    },
                                    id: "heading-desc",
                                    alignSelf: "center",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        px: {
                                            md: 10
                                        },
                                        fontSize: "4xl",
                                        fontWeight: "bold",
                                        color: "#006400",
                                        textAlign: {
                                            base: 'center',
                                            md: 'left'
                                        },
                                        children: (ref3 = props.review) === null || ref3 === void 0 ? void 0 : ref3.description
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                            as: "div",
                            ref: videoBoxRef,
                            id: "review-video",
                            position: "relative",
                            overflow: "hidden",
                            borderRadius: "2xl",
                            boxShadow: "xl",
                            bgColor: "black",
                            h: "670px",
                            w: "1200px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "2xl",
                                    boxShadow: "xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ref: playerRef,
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        url: (ref4 = props.review) === null || ref4 === void 0 ? void 0 : ref4.video,
                                        width: "100%",
                                        height: "100%",
                                        controls: false,
                                        playing: play,
                                        volume: volume,
                                        muted: isMuted,
                                        playbackRate: playbackRate,
                                        onProgress: handleProgress,
                                        onEnded: function() {
                                            return setPlay(false);
                                        },
                                        playsinline: true,
                                        playIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                            id: "start-video-learn-btn",
                                            h: "700px",
                                            w: "1200px",
                                            onClick: playVideo,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                position: "relative",
                                                h: "150px",
                                                w: "150px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    id: "img-start-video-learn-btn",
                                                    onClick: playVideo,
                                                    src: "https://res.cloudinary.com/hfq3eckim/image/upload/v1651132886/csv2/Icons/Play_Button_aobpih.svg",
                                                    alt: "play-button",
                                                    layout: "fill",
                                                    priority: true
                                                })
                                            })
                                        }),
                                        light: ((ref5 = props.review) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.placeholder) === null || ref6 === void 0 ? void 0 : ref6.publicUrl) ? (ref7 = props.review) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.placeholder) === null || ref8 === void 0 ? void 0 : ref8.publicUrl : ''
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    display: mainPlay ? 'flex' : 'none',
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    bottom: 10,
                                    zIndex: 1,
                                    h: "25px",
                                    w: "full",
                                    justify: "space-around",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            cursor: "pointer",
                                            onClick: handleRewind,
                                            position: "relative",
                                            w: "25px",
                                            h: "25px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: reverseIcon,
                                                alt: "reverse-icon"
                                            })
                                        }),
                                        play ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            id: "pause-learn-btn",
                                            cursor: "pointer",
                                            onClick: function() {
                                                return setPlay(false);
                                            },
                                            position: "relative",
                                            w: "25px",
                                            h: "25px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: pauseIcon,
                                                alt: "pause-icon"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            id: "play-learn-btn",
                                            cursor: "pointer",
                                            onClick: function() {
                                                return setPlay(true);
                                            },
                                            position: "relative",
                                            w: "25px",
                                            h: "25px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: playIcon,
                                                alt: "play-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            cursor: "pointer",
                                            onClick: handleFastForward,
                                            position: "relative",
                                            w: "25px",
                                            h: "25px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: fastForwardIcon,
                                                alt: "forward-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            color: "white",
                                            children: elapsedTime
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                                            h: "25px",
                                            justify: "space-between",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                w: "550px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_slider_esm/* Slider */.iR, {
                                                    minH: "32px",
                                                    min: 0,
                                                    max: 100,
                                                    value: played * 100,
                                                    onChange: function(val) {
                                                        return handleSeekChange(val);
                                                    },
                                                    onMouseDown: handleSeekMouseDown,
                                                    onChangeEnd: function(val) {
                                                        return handleSeekMouseUp(val);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderTrack */.Uj, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderFilledTrack */.Ms, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderThumb */.gs, {})
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            color: "white",
                                            children: totalDuration
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                            onMouseEnter: function() {
                                                return setShowVolumeSlider(true);
                                            },
                                            onMouseLeave: function() {
                                                return setShowVolumeSlider(false);
                                            },
                                            cursor: "pointer",
                                            h: "25px",
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                    position: "relative",
                                                    w: "70px",
                                                    h: "25px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        layout: "fill",
                                                        src: volumeIcon,
                                                        alt: "volume-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                    w: "90px",
                                                    display: showVolumeSlider ? 'flex' : 'none',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_slider_esm/* Slider */.iR, {
                                                        minH: "32px",
                                                        defaultValue: 20,
                                                        value: volume * 100,
                                                        onChange: function(val) {
                                                            return handleVolumeChange(val);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderTrack */.Uj, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderFilledTrack */.Ms, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* SliderThumb */.gs, {})
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* Menu */.v2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuButton */.j2, {
                                                    as: chakra_ui_layout_esm/* Box */.xu,
                                                    cursor: "pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                        position: "relative",
                                                        w: "25px",
                                                        h: "25px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            layout: "fill",
                                                            src: settingsIcon,
                                                            alt: "settings-icon"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuList */.qy, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* MenuOptionGroup */.__, {
                                                        defaultValue: "1",
                                                        title: "Speed",
                                                        type: "radio",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItemOption */.ii, {
                                                                onClick: function() {
                                                                    return setPlaybackRate(1);
                                                                },
                                                                value: "1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                    children: "1x"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItemOption */.ii, {
                                                                onClick: function() {
                                                                    return setPlaybackRate(1.5);
                                                                },
                                                                value: "1.5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                    children: "1.5x"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItemOption */.ii, {
                                                                onClick: function() {
                                                                    return setPlaybackRate(2);
                                                                },
                                                                value: "2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                    children: "2x"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            onClick: toggleFullScreen,
                                            cursor: "pointer",
                                            position: "relative",
                                            w: "40px",
                                            h: "25px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: fullScreenIcon,
                                                alt: "full-screen-icon"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var HeaderAndVideo_HeaderVideo = (HeaderVideo);

;// CONCATENATED MODULE: ./src/page-components/review/Review.tsx





var Review = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Review | Chacra Software Solutions"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderAndVideo_HeaderVideo, {
                review: props.review
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact_Contact, {
                review: props.review
            })
        ]
    });
};
/* harmony default export */ var review_Review = (Review);

;// CONCATENATED MODULE: ./src/page-components/review/index.ts


;// CONCATENATED MODULE: ./src/pages/r/[userId].tsx
var __N_SSG = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4,241,774,888,179], function() { return __webpack_exec__(5829); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);